import { render, staticRenderFns } from "./StudentHistoryContent.vue?vue&type=template&id=53595b46&scoped=true&lang=pug&"
import script from "./StudentHistoryContent.vue?vue&type=script&lang=ts&"
export * from "./StudentHistoryContent.vue?vue&type=script&lang=ts&"
import style0 from "./StudentHistoryContent.vue?vue&type=style&index=0&id=53595b46&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53595b46",
  null
  
)

export default component.exports